import { createSvgIcon } from '@mui/material';

export const DiscoverIcon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    // width='53'
    // height='39'
    // viewBox='0 0 53 39'
    width='46'
    height='30'
    viewBox='0 0 46 30'
    fill='none'
  >
    <g filter='url(#filter0_dd_19243_22616)'>
      <rect
        x='8'
        y='4'
        width='37.2537'
        height='24'
        rx='4.29851'
        fill='#FEF3E9'
      />
      <rect
        x='7.91045'
        y='3.91045'
        width='37.4328'
        height='24.1791'
        rx='4.38806'
        stroke='#D6DCE5'
        strokeWidth='0.179104'
      />
      <path
        d='M21.0258 16.0616C21.0258 17.3881 22.0676 18.4164 23.4076 18.4164C23.7867 18.4164 24.1108 18.3417 24.511 18.1536V17.1176C24.1592 17.4694 23.8476 17.6115 23.4484 17.6115C22.5619 17.6115 21.9327 16.9689 21.9327 16.055C21.9327 15.1889 22.5823 14.5054 23.4076 14.5054C23.8275 14.5054 24.1454 14.6549 24.511 15.0128V13.9772C24.125 13.7815 23.8071 13.7002 23.4284 13.7002C22.0949 13.7002 21.0258 14.7497 21.0258 16.0616Z'
        fill='#251F1F'
      />
      <path
        d='M18.7668 14.9658C18.7668 15.2093 18.9221 15.3384 19.4503 15.5338C20.4517 15.9001 20.7484 16.2245 20.7484 16.9415C20.7484 17.8149 20.1064 18.423 19.1919 18.423C18.5222 18.423 18.0352 18.1594 17.6295 17.5641L18.1982 17.0166C18.4008 17.4085 18.7391 17.6185 19.1587 17.6185C19.5516 17.6185 19.8422 17.3476 19.8422 16.982C19.8422 16.7925 19.754 16.6295 19.5783 16.515C19.4897 16.4607 19.3143 16.3794 18.9699 16.2581C18.1431 15.9606 17.8595 15.6424 17.8595 15.0205C17.8595 14.282 18.4686 13.7275 19.2669 13.7275C19.7616 13.7275 20.2143 13.8967 20.5931 14.228L20.1323 14.8309C19.903 14.574 19.6865 14.4653 19.4226 14.4653C19.0431 14.4653 18.7668 14.6815 18.7668 14.9658Z'
        fill='#251F1F'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.5906 13.8023H12.2983V18.3147H13.5837C14.2668 18.3147 14.7607 18.1536 15.1938 17.7938C15.7085 17.3677 16.0128 16.7254 16.0128 16.0616C16.0128 14.73 15.0177 13.8023 13.5906 13.8023ZM14.6185 17.1923C14.3419 17.4417 13.9828 17.5507 13.4141 17.5507H13.1779V14.567H13.4141C13.9828 14.567 14.3276 14.6684 14.6185 14.9319C14.9233 15.2028 15.1059 15.6227 15.1059 16.055C15.1059 16.4881 14.9233 16.9215 14.6185 17.1923Z'
        fill='#251F1F'
      />
      <path
        d='M17.2982 13.8023H16.4178V18.3147H17.2982V13.8023Z'
        fill='#251F1F'
      />
      <path
        d='M30.2865 13.8023L31.4902 16.8329L32.7092 13.8023H33.6631L31.7136 18.4306H31.2401L29.3253 13.8023H30.2865Z'
        fill='#251F1F'
      />
      <path
        d='M34.0612 18.3147H36.5574V17.5507H34.9408V16.3328H36.4977V15.5684H34.9408V14.567H36.5574V13.8023H34.0612V18.3147Z'
        fill='#251F1F'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M38.4453 13.8023C39.4605 13.8023 40.043 14.2896 40.043 15.1342C40.043 15.8254 39.6774 16.2788 39.0143 16.4137L40.4349 18.3147H39.3526L38.1344 16.5019H38.0192V18.3147H37.1403V13.8023H38.4453ZM38.0192 15.8797H38.2769C38.839 15.8797 39.1368 15.6355 39.1368 15.182C39.1368 14.7427 38.839 14.5127 38.2904 14.5127H38.0192V15.8797Z'
        fill='#251F1F'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M40.7444 14.0388C40.7444 13.9594 40.6893 13.916 40.5935 13.916H40.4659V14.3141H40.5606V14.1599L40.6718 14.3141H40.7881L40.6572 14.15C40.713 14.1347 40.7444 14.0939 40.7444 14.0388ZM40.5767 14.0932H40.5606V13.9889H40.5778C40.6248 13.9889 40.6492 14.006 40.6492 14.0403C40.6492 14.0753 40.6244 14.0932 40.5767 14.0932Z'
        fill='#251F1F'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M40.2657 14.1143C40.2657 13.9215 40.4196 13.7673 40.6124 13.7673C40.8005 13.7673 40.9551 13.9244 40.9551 14.1143C40.9551 14.3053 40.8005 14.4613 40.6124 14.4613C40.421 14.4613 40.2657 14.3068 40.2657 14.1143ZM40.3346 14.1147C40.3346 14.2729 40.4589 14.3993 40.6109 14.3993C40.7626 14.3993 40.8858 14.2714 40.8858 14.1147C40.8858 13.9594 40.7626 13.8296 40.6109 13.8296C40.4578 13.8296 40.3346 13.9564 40.3346 14.1147Z'
        fill='#251F1F'
      />
      <g filter='url(#filter1_i_19243_22616)'>
        <path
          d='M27.1789 18.4518C25.86 18.4518 24.7905 17.3823 24.7905 16.0635V16.0602C24.7905 15.404 25.0562 14.807 25.486 14.3772C25.486 14.3739 25.4893 14.3739 25.4893 14.3707C25.4926 14.3707 25.4926 14.3673 25.4959 14.3673C25.9256 13.9376 26.5228 13.6719 27.1789 13.6719H27.1822C28.5011 13.6719 29.5706 14.7414 29.5706 16.0602V16.0635C29.5706 16.7197 29.3048 17.3135 28.875 17.7465C28.875 17.7498 28.8718 17.7498 28.8718 17.7531C28.8684 17.7531 28.8684 17.7563 28.8652 17.7563C28.4321 18.1861 27.8383 18.4518 27.1822 18.4518H27.1789Z'
          fill='url(#paint0_linear_19243_22616)'
        />
      </g>
    </g>
    <defs>
      <filter
        id='filter0_dd_19243_22616'
        x='0.656622'
        y='0.238711'
        width='51.9402'
        height='38.6868'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='0.358209' />
        <feGaussianBlur stdDeviation='1.79104' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_19243_22616'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='3.58209' />
        <feGaussianBlur stdDeviation='3.58209' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0'
        />
        <feBlend
          mode='normal'
          in2='effect1_dropShadow_19243_22616'
          result='effect2_dropShadow_19243_22616'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect2_dropShadow_19243_22616'
          result='shape'
        />
      </filter>
      <filter
        id='filter1_i_19243_22616'
        x='24.7905'
        y='13.6719'
        width='4.95524'
        height='5.04224'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='0.174971' dy='0.262457' />
        <feGaussianBlur stdDeviation='0.174971' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_19243_22616'
        />
      </filter>
      <linearGradient
        id='paint0_linear_19243_22616'
        x1='25.9278'
        y1='13.6719'
        x2='29.8555'
        y2='16.9954'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#EF3823' />
        <stop offset='0.489583' stopColor='#F04D22' />
        <stop offset='1' stopColor='#F7911D' />
      </linearGradient>
    </defs>
  </svg>,
  'DiscoverIcon',
);
